import assertNever from 'assert-never';
import {
    guidConvert,
    isIPrimitive
} from '@ef-carbon/primitive';
import { isGroup } from './isGroup';
import isIConditional from './isIConditional';
import isIDirect from './isIDirect';
import isIRandom from './isIRandom';
import isIRemote from './isIRemote';
function groupsGet(selection, groups) {
    if (!groups) {
        return [];
    }
    const group = groups.get(selection);
    if (!group) {
        return [];
    }
    return group;
}
function add(link, options, set) {
    if (typeof link === 'string' || isIPrimitive(link)) {
        set.add(guidConvert(link));
        return set;
    } else if (link.redirect) {
        set.add(guidConvert(link.redirect));
    }
    if (isIDirect(link)) {
        add(link.id, options, set);
        return set;
    } else if (isIConditional(link)) {
        for (const id of Object.values(link.conditions)) {
            add(id, options, set);
        }
        add(link.fallback, options, set);
        return set;
    } else if (isIRandom(link)) {
        const selection = link.ids;
        const ids = !isGroup(selection) ? selection : groupsGet(selection, options.groups);
        for (const id of ids) {
            add(id, options, set);
        }
        return set;
    } else if (isIRemote(link)) {
        return set;
    } else {
        return assertNever(link);
    }
}
export function linkPossibles(link, options = {}) {
    const set = new Set();
    return add(link, options, set);
}
export {
    linkPossibles as possibles
};
export default linkPossibles;    //# sourceMappingURL=possibles.js.map
